// extracted by mini-css-extract-plugin
export var nav = "styles-module--nav--1bc00";
export var white = "styles-module--white--43ed0";